// Pick localized fields from a top token object based on i18n language.
export function localized(t, i18n) {
    const isIt = (i18n?.language || "en").startsWith("it");
    return {
        title: isIt && t.title_it ? t.title_it : t.title,
        quote: isIt && t.quote_it ? t.quote_it : t.quote,
        description: isIt && t.description_it ? t.description_it : t.description,
    };
}
